import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { useTheme } from '@fcms/ui'
import '@fcms/ui/styles.css'
import './styles/app.css'
import { initLocale } from './i18n'
import App from './App.vue'
import router from './router'

// Dhivehi-first: the very first paint must already be dir="rtl" lang="dv"
// (or a previously-saved choice), so this runs before the app is created —
// never after mount, where a flash of the wrong direction would be visible.
initLocale()

// The same, for the saved theme. `useTheme()` is what writes
// <html data-theme>, and it only does so once something calls it — which in
// this app was ProfileView alone. A fisherman who chose dark got it while that
// screen was open and a light app on the next load, because nothing on the
// startup path had ever installed the composable. The back office has always
// called it from its shell store; this is the portal's equivalent.
useTheme()

const app = createApp(App)
app.use(createPinia())
app.use(router)

// App.vue's `showShell` reads `route.meta.public` on first render; mounting
// before the router has resolved its initial route means that read sees
// `undefined` and briefly shows the authenticated shell (which fires
// `auth.loadProfile()` / `announcements.refreshUnreadCount()`) even for an
// anonymous visitor on a public page. Awaiting `isReady()` means the first
// render already has the real route.
router.isReady().then(() => {
  app.mount('#app')
})
